import React, { useState } from "react";
import { Box, TextField, Typography } from "@material-ui/core";
import PageTitleHeader from "components/Headers/PageTitleHeader";
import GenericButton from "components/Buttons/GenericButton";
import GenericDialog from "components/Dialogs/GenericDialogV2";

const CancelModal = ({ open, onClose, onConfirm, isLoading }) => {
  const [motive, setMotive] = useState("");

  const handleConfirm = () => {
    onConfirm(motive);
  };

  const handleClose = () => {
    setMotive("");
    onClose();
  };

  return (
    <GenericDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "-22px",
        }}
      >
        <PageTitleHeader title="Cancelar Submissão do Mapa RENT" />
      </Box>

      <Typography variant="body1" style={{ marginBottom: "1rem" }}>
        Deseja mesmo cancelar a submissão do mapa RENT? Por favor, indique o motivo do cancelamento.
      </Typography>

      <TextField
        label="Motivo do Cancelamento"
        multiline
        minRows={4}
        maxRows={8}
        fullWidth
        variant="outlined"
        value={motive}
        onChange={(e) => setMotive(e.target.value)}
        inputProps={{ maxLength: 1000 }}
        style={{ marginBottom: "1.5rem" }}
      />

      <Box display="flex" justifyContent="flex-end" gridGap={12}>
        <GenericButton onClick={handleClose} color="tertiary" disabled={isLoading}>
          Cancelar
        </GenericButton>
        <GenericButton
          onClick={handleConfirm}
          color="tertiaryRed"
          loading={isLoading}
          disabled={!motive.trim()}
        >
          Confirmar Cancelamento
        </GenericButton>
      </Box>
    </GenericDialog>
  );
};

export default CancelModal;
